// hooks/useTicketSearch.js
import { useState } from "react";
import { useDebouncedValue } from "@mantine/hooks";
import { useGetAllTickets } from "../api/tickets";

export function useTicketSearch(eventId) {
  const [searchValue, setSearchValue] = useState("");
  const [debouncedValue] = useDebouncedValue(searchValue, 300);

  const {
    data: ticketsResponse,
    isPending,
    isError,
    error,
  } = useGetAllTickets({
    eventId,
    searchQuery: debouncedValue,
  });

  const tickets = ticketsResponse?.data || [];

  const options = tickets.map((ticket) => {
    const fullName = `${ticket.firstName} ${ticket.lastName}`;
    const occupation = ticket.occupation ? `, ${ticket.occupation}` : "";
    return {
      value: ticket.id.toString(),
      label: `${fullName}${occupation}`,
    };
  });

  return {
    searchValue,
    setSearchValue,
    tickets,
    options,
    isPending,
    isError,
    error,
  };
}
